module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Salenstein-1a09d4a45c7b2742df0b7f5c0253c75f.png";